import type { DOMOutputSpec, MarkSpec } from 'prosemirror-model';

import type { RtSchemaType } from '../../../editor/types';
import { MarkName } from '../../../schema/marks';

export class UnderlineMark implements MarkSpec {
  public static readonly markName = MarkName.Underline;
  public parseDOM = [{ tag: 'u' }, { tag: 'underline' }, { style: 'text-decoration=underline' }];
  public toDOM(): DOMOutputSpec {
    return ['u', 0];
  }
}

export type UnderlineSchema = RtSchemaType<any, typeof UnderlineMark>;
